(function () {
  'use strict';
 
  document.addEventListener('DOMContentLoaded', init);
 
  function init() {
    (window.countySelectorConfig || []).forEach(setupInstance);
  }
 
  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;
 
    if (!window.ProductAddonsCore) {
      console.error('county-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }
 
    var groupsContainer = root.querySelector('[data-county-groups]');
    var addBtn = root.querySelector('[data-county-add-btn]');
    var addPriceEl = root.querySelector('[data-county-add-price]');
    var priceSummaryEl = root.querySelector('[data-county-price-summary]');
    var errorEl = root.querySelector('[data-county-error]');
    var selectTemplate = root.querySelector('[data-county-select-template]');
 
    var maxCounties = config.maxCounties || 8;
    var firstPrice = config.firstPrice;
    var additionalPrice = config.additionalPrice;
    var required = !!config.required;
    var addonVariants = config.addonVariants || {};
 
    var countyData = null;
    var dataLoaded = false;
    var groups = []; // { index, stateSelect, countySelect }
 
    fetch(config.dataUrl, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        countyData = data;
        dataLoaded = true;
        addGroup(); // first county group is always present
      })
      .catch(function (err) {
        showError('Could not load the county list. Please refresh and try again.');
        console.error('county-selector: failed to load counties.json', err);
      });
 
    addBtn.addEventListener('click', function () {
      if (groups.length >= maxCounties) return;
      addGroup();
    });
 
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);
 
    function cloneSelectWrapper() {
      var fragment = selectTemplate.content.cloneNode(true);
      var wrapper = fragment.querySelector('.select-wrapper');
      var select = wrapper.querySelector('select');
      return { wrapper: wrapper, select: select };
    }
 
    function addGroup() {
      var index = groups.length + 1;
      if (index > maxCounties) return;
 
      var wrapper = document.createElement('div');
      wrapper.className = 'county-selector__group product__controls-group product__block product__block--medium';
      wrapper.dataset.countyIndex = index;
 
      var labelRow = document.createElement('div');
      labelRow.className = 'county-selector__group-label-row';
 
      var labelWrap = document.createElement('div');
      labelWrap.className = 'product__label-wrapper';
      var label = document.createElement('label');
      label.className = 'product__label ff-heading fs-heading-4-base';
      var price = index === 1 ? firstPrice : additionalPrice;
      var priceLabel = price > 0 ? (' (+' + formatMoney(price) + ')') : ' (Included)';
      label.textContent = ordinalWord(index) + ' County' + priceLabel;
      labelWrap.appendChild(label);
      labelRow.appendChild(labelWrap);
 
      if (index > 1) {
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'btn btn--text-link county-selector__remove-group';
        removeBtn.textContent = 'Remove';
        removeBtn.addEventListener('click', function () {
          if (index !== groups.length) return; // only the last group is removable
          wrapper.remove();
          groups.pop();
          updateAddButton();
          updatePriceSummary();
        });
        labelRow.appendChild(removeBtn);
      }
 
      wrapper.appendChild(labelRow);
 
      var row = document.createElement('div');
      row.className = 'county-selector__row';
 
      var stateField = cloneSelectWrapper();
      stateField.select.className = 'input county-selector__state';
      stateField.select.setAttribute('aria-label', ordinalWord(index) + ' county - state');
      stateField.select.innerHTML = buildStateOptions(countyData);
 
      var countyField = cloneSelectWrapper();
      countyField.select.className = 'input county-selector__county';
      countyField.select.setAttribute('aria-label', ordinalWord(index) + ' county - county');
      countyField.select.disabled = true;
      countyField.select.innerHTML = '<option value="">Select a state first&hellip;</option>';
 
      stateField.select.addEventListener('change', function () {
        var entry = countyData.states.find(function (s) {
          return s.code === stateField.select.value;
        });
        if (entry) {
          countyField.select.innerHTML = buildCountyOptions(entry);
          countyField.select.disabled = false;
        } else {
          countyField.select.innerHTML = '<option value="">Select a state first&hellip;</option>';
          countyField.select.disabled = true;
        }
        updatePriceSummary();
      });
      countyField.select.addEventListener('change', updatePriceSummary);
 
      row.appendChild(stateField.wrapper);
      row.appendChild(countyField.wrapper);
      wrapper.appendChild(row);
      groupsContainer.appendChild(wrapper);
 
      groups.push({ index: index, stateSelect: stateField.select, countySelect: countyField.select });
      clearError();
      updateAddButton();
      updatePriceSummary();
    }
 
    function updateAddButton() {
      if (groups.length >= maxCounties) {
        addBtn.hidden = true;
        return;
      }
      addBtn.hidden = false;
      addPriceEl.textContent = ' (+' + formatMoney(additionalPrice) + ')';
    }
 
    function updatePriceSummary() {
      var total = 0;
      var filled = 0;
      groups.forEach(function (g, i) {
        if (g.countySelect.value) {
          filled += 1;
          total += i === 0 ? firstPrice : additionalPrice;
        }
      });
      priceSummaryEl.textContent = filled > 0
        ? 'County programming add-on (' + filled + '): ' + formatMoney(total)
        : '';
 
      if (window.ProductAddonsCore && window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
    }
 
    // Live price preview only — no validation, no error UI. Kept
    // separate from getContribution (below) since that one runs
    // validation and shows error messages, which would be wrong to
    // trigger just from a price recalculation.
    function getPriceContribution() {
      var total = 0;
      groups.forEach(function (g, i) {
        if (g.countySelect.value) {
          total += i === 0 ? firstPrice : additionalPrice;
        }
      });
      return total;
    }
 
    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    function getContribution() {
      if (!dataLoaded) {
        showError('Still loading county options — please try again in a moment.');
        return { ok: false };
      }
 
      var allGroups = groups.map(function (g) {
        return { index: g.index, state: g.stateSelect.value, county: g.countySelect.value };
      });
 
      // A group with a state chosen but no county yet is an incomplete
      // selection — block submission and ask specifically for the
      // county. A group with neither state nor county set is simply
      // unused (this whole option is optional), not an error.
      var incomplete = allGroups.filter(function (s) { return s.state && !s.county; });
      if (incomplete.length) {
        showError('Please select a county.');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return { ok: false };
      }
 
      var selections = allGroups.filter(function (s) { return s.state && s.county; });
 
      // On a scanner page this option is fully optional — no
      // selections at all is valid. On the Preprogrammed SD Card page
      // (required === true), at least one county must be selected,
      // since preprogramming depends on knowing it.
      if (selections.length === 0) {
        if (required) {
          showError('Please select a county.');
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return { ok: false };
        }
        clearError();
        return { ok: true, items: [] };
      }
 
      var missing = selections.filter(function (s) { return !addonVariants[s.index]; });
      if (missing.length) {
        showError('This option isn\u2019t configured correctly. Please contact support.');
        console.error(
          'county-selector: no addon variant configured for position(s)',
          missing.map(function (m) { return m.index; })
        );
        return { ok: false };
      }
 
      clearError();
 
      var items = selections.map(function (s) {
        var addon = addonVariants[s.index];
        return {
          id: addon.variantId,
          quantity: 1,
          properties: { 'County': s.county + ', ' + s.state }
        };
      });
 
      return { ok: true, items: items };
    }
 
    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
 
    function ordinalWord(n) {
      var words = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth'];
      return words[n - 1] || (n + 'th');
    }
 
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
 
    function buildStateOptions(data) {
      var out = ['<option value="">Select a state&hellip;</option>'];
      data.states
        .slice()
        .sort(function (a, b) { return a.name.localeCompare(b.name); })
        .forEach(function (s) { out.push('<option value="' + s.code + '">' + s.name + '</option>'); });
      return out.join('');
    }
 
    function buildCountyOptions(stateEntry) {
      var out = ['<option value="">Select a county&hellip;</option>'];
      stateEntry.counties.forEach(function (c) {
        out.push('<option value="' + escapeHtml(c.name) + '">' + escapeHtml(c.name) + '</option>');
      });
      return out.join('');
    }
 
    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }
})();